import { render, staticRenderFns } from "./saas-loading.vue?vue&type=template&id=131fa8e0&scoped=true"
import script from "./saas-loading.vue?vue&type=script&lang=js"
export * from "./saas-loading.vue?vue&type=script&lang=js"
import style0 from "./saas-loading.vue?vue&type=style&index=0&id=131fa8e0&prod&lang=scss&scoped=true"
import style1 from "./saas-loading.vue?vue&type=style&index=1&id=131fa8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131fa8e0",
  null
  
)

export default component.exports